var _circle, _circle2, _path, _path2, _path3, _g, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcomeWarrior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#3F234B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 12.9375,
    stroke: "url(#paint0_linear_83_56434)",
    strokeWidth: 1.125
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3828 11.9434C19.3802 11.7808 19.2871 11.6357 19.142 11.5623L15.0681 9.5153C14.9449 9.45323 14.7993 9.45323 14.6756 9.5153L10.6017 11.5623C10.4562 11.6357 10.3635 11.7808 10.3609 11.9434C10.3421 13.1162 10.5336 17.8444 14.7246 19.2685C14.8181 19.3004 14.9252 19.3004 15.0187 19.2685C19.2102 17.8444 19.4016 13.1162 19.3828 11.9434ZM16.758 13.9874L16.1032 14.6255C16.0416 14.6859 16.0132 14.7724 16.028 14.8572L16.1828 15.7581C16.2195 15.9718 15.9952 16.1349 15.8029 16.0339L14.9938 15.6086C14.9178 15.5684 14.8264 15.5684 14.7504 15.6086L13.9413 16.0339C13.7494 16.1349 13.5251 15.9718 13.5614 15.7581L13.7162 14.8572C13.7306 14.7724 13.7026 14.6859 13.641 14.6255L12.9862 13.9874C12.831 13.8361 12.9167 13.5721 13.1313 13.5411L14.0361 13.4095C14.1214 13.3973 14.1952 13.3435 14.2333 13.2661L14.638 12.4466C14.7342 12.252 15.0113 12.252 15.1075 12.4466L15.5122 13.2661C15.5503 13.3435 15.6241 13.3968 15.7094 13.4095L16.6142 13.5411C16.8275 13.5726 16.9132 13.8361 16.758 13.9874Z",
    fill: "url(#paint1_linear_83_56434)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2226 16.4473C18.7999 17.3206 18.2207 18.121 17.4575 18.7736L18.9446 20.2606L19.4997 18.7744L20.9907 18.2154L19.2226 16.4473Z",
    fill: "url(#paint2_linear_83_56434)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5205 16.4473L8.75244 18.2154L10.243 18.7749L10.7981 20.261L12.2852 18.774C11.5224 18.1214 10.9432 17.321 10.5205 16.4473Z",
    fill: "url(#paint3_linear_83_56434)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_83_56434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8676 12.6367L14.3907 13.9083L13.1191 14.3852L14.3907 14.862L14.8676 16.1336L15.3444 14.862L16.616 14.3852L15.3444 13.9083L14.8676 12.6367Z",
    fill: "#FDF3F3"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0051 17.4902L16.7699 18.1175L16.1426 18.3527L16.7699 18.588L17.0051 19.2152L17.2403 18.588L17.8676 18.3527L17.2403 18.1175L17.0051 17.4902Z",
    fill: "#FDF3F3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_83_56434",
    x: 11.5344,
    y: 11.0519,
    width: 6.66638,
    height: 6.66564,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.792388,
    result: "effect1_foregroundBlur_83_56434"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_56434",
    x1: 15,
    y1: 1.5,
    x2: 15,
    y2: 28.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_56434",
    x1: 14.8719,
    y1: 9.46875,
    x2: 14.8719,
    y2: 19.2925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_83_56434",
    x1: 19.2241,
    y1: 16.4473,
    x2: 19.2241,
    y2: 20.2606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78CA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_83_56434",
    x1: 10.5188,
    y1: 16.4473,
    x2: 10.5188,
    y2: 20.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F16480"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F78CA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeWarrior);
export default __webpack_public_path__ + "static/media/welcome-warrior.79d3677352ff005d34c6689dcb406ea2.svg";
export { ForwardRef as ReactComponent };